import { useMemo } from 'react';
import {
  i18nInit,
  useLanguageControlOverrides,
  useLoadLocale
} from '@elfsight/lib-i18n';
import { LOCAL_WIDGET_ID, WidgetTokenProvider } from '@elfsight/lib-utils';
import { useFontsLoader } from '@elfsight/widget-ui';
import { WidgetRectProvider } from '@elfsight/widget-utils';
import { I18nProvider } from '@lingui/react';
import { useSettings } from '@wu/widget-core';
import CATALOG from '../i18n/languages/widget/catalog.json';
import { ImagesProvider } from './widget/components/images';
import { LightboxProvider } from './widget/components/lightbox';
import { Widget } from './widget/widget';

export function PhotoGallery() {
  const { font, language, widgetId, widgetToken } = useSettings();

  const i18n = useMemo(() => i18nInit(), []);
  const messages = useLoadLocale(language?.language, 'widget', i18n);
  useLanguageControlOverrides({ language, messages, catalog: CATALOG, i18n });
  useFontsLoader([font]);

  return (
    <I18nProvider i18n={i18n}>
      <WidgetTokenProvider
        widgetToken={widgetToken}
        widgetId={widgetId || LOCAL_WIDGET_ID}
      >
        <LightboxProvider>
          <ImagesProvider>
            <WidgetRectProvider>
              <Widget />
            </WidgetRectProvider>
          </ImagesProvider>
        </LightboxProvider>
      </WidgetTokenProvider>
    </I18nProvider>
  );
}
